import React from "react";
import {ColumnProps} from "antd/es/table";
import {FIELD_TYPE} from "types/enums";
import {formatToCurrencyType} from "helper/common";
const {INPUT, COMBO_BOX, CURRENCY} = FIELD_TYPE;

const columns: any[] = [
  {
    key: "stt",
    title: "STT",
    dataIndex: "stt",
    render(value, record, index) {
      return <>{index + 1}</>;
    },
    width: 80,
    align: "center",
  },

  {
    key: "idVtyt",
    title: "Mã VTYT",
    dataIndex: "idVtyt",
    width: 100,
  },
  {
    key: "maBaoHiem",
    title: "Mã bảo hiểm",
    dataIndex: "maBaoHiem",
    width: 250,
  },
  {
    key: "tenTheoBaoHiem",
    title: "Tên theo BH",
    dataIndex: "tenTheoBaoHiem",
    width: 250,
  },
  {
    key: "tenTheoThuongMai",
    title: "Tên thương mại",
    dataIndex: "tenTheoThuongMai",
    width: 250,
  },
  {
    key: "maHang",
    title: "Mã hàng",
    dataIndex: "maHang",
    width: 150,
  },
  {
    key: "quyCach",
    title: "Quy cách",
    dataIndex: "quyCach",
    width: 200,
  },
  {
    key: "nhomVTYT",
    title: "Nhóm VTYT",
    dataIndex: "nhomVTYT",
    width: 200,
  },
  {
    key: "hangSanXuat",
    title: "Hãng sản xuất",
    dataIndex: "hangSanXuat",
    width: 250,
  },
  {
    key: "nuocSanXuat",
    title: "Nước sản xuất",
    dataIndex: "nuocSanXuat",
    width: 200,
  },
  {
    key: "donViTinh",
    title: "Đơn vị tính",
    dataIndex: "donViTinh",
    width: 200,
  },
  {
    key: "giaTriBHChiTra",
    title: "Giá trị BH chi trả",
    dataIndex: "giaTriBHChiTra",
    width: 200,
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
    align: "right",
  },
  {
    key: "donViApKQDT",
    title: "Tên đơn vị áp KQĐT",
    dataIndex: "donViApKQDT",
    width: 200,
  },
  {
    key: "nhaThau",
    title: "Nhà thầu trúng thầu",
    dataIndex: "nhaThau",
    width: 250,
  },
  {
    key: "nhomTCKT",
    title: "Nhóm TCKT",
    dataIndex: "nhomTCKT",
    width: 250,
  },
  {
    key: "description",
    title: "Mô tả",
    dataIndex: "description",
    width: 200,
  },
  {
    key: "action",
    title: "Thao tác",
    dataIndex: "action",
    width: 80,
    fixed: "right",
  },
];
const dataFields: any[] = [
  {
    type: INPUT,
    label: "Mã VTYT",
    name: "idVtyt",
    disable: true,
  },
  {
    type: INPUT,
    label: "Mã VTYT",
    name: "id",
    disable: true,
    hide: true,
  },
  {
    type: INPUT,
    label: "Mã bảo hiểm",
    name: "maBaoHiem",
    rules: [{required: true, message: "Chưa nhập Mã bảo hiểm"}],
  },
  {
    type: INPUT,
    label: "Tên theo BH",
    name: "tenTheoBaoHiem",
    rules: [{required: true, message: "Chưa nhập Tên theo BH"}],
  },
  {
    type: INPUT,
    label: "Tên thương mại",
    name: "tenTheoThuongMai",
    rules: [{required: true, message: "Chưa nhập Tên thương mại"}],
  },
  {
    type: INPUT,
    label: "Mã hàng",
    name: "maHang",
    rules: [{required: true, message: "Chưa nhập Mã hàng"}],
  },
  {
    type: COMBO_BOX,
    label: "Quy cách",
    name: "quyCachId",
  },
  {
    type: COMBO_BOX,
    label: "Nhóm VTYT",
    name: "nhomVTYTId",
    rules: [{required: true, message: "Chưa chọn Nhóm VTYT"}],
  },
  {
    type: COMBO_BOX,
    label: "Hãng sản xuất",
    name: "hangSanXuatId",
  },
  {
    type: COMBO_BOX,
    label: "Nước sản xuất",
    name: "nuocSanXuatId",
  },
  {
    type: COMBO_BOX,
    label: "Đơn vị tính",
    name: "donViTinhId",
    rules: [{required: true, message: "Chưa chọn Đơn vị tính"}],
  },
  {
    type: CURRENCY,
    label: "Giá trị BH chi trả",
    name: "giaTriBHChiTra",
    rules: [{required: true, message: "Chưa nhập Giá trị BH chi trả"}],
  },
  // {
  //   type: COMBO_BOX,
  //   label: "Tên đơn vị áp KQĐT",
  //   name: "donViApKQDTId",
  // },
  {
    type: INPUT,
    label: "Nhà thầu trúng thầu",
    name: "nhaThau",
  },
  {
    type: INPUT,
    label: "Nhóm TCKT",
    name: "nhomTCKT",
  },
  {
    type: INPUT,
    label: "Ghi chú",
    name: "description",
  },
];
export {columns, dataFields};
